function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0312 5.18466H6.65625V0.809662C6.65625 0.754974 6.62891 0.709401 6.57422 0.672943C6.53776 0.618256 6.49219 0.590912 6.4375 0.590912H5.5625C5.50781 0.590912 5.45312 0.618256 5.39844 0.672943C5.36198 0.709401 5.34375 0.754974 5.34375 0.809662V5.18466H0.96875C0.914062 5.18466 0.859375 5.21201 0.804688 5.26669C0.768229 5.30315 0.75 5.34872 0.75 5.40341V6.27841C0.75 6.3331 0.768229 6.38779 0.804688 6.44247C0.859375 6.47893 0.914062 6.49716 0.96875 6.49716H5.34375V10.8722C5.34375 10.9268 5.36198 10.9815 5.39844 11.0362C5.45312 11.0727 5.50781 11.0909 5.5625 11.0909H6.4375C6.49219 11.0909 6.53776 11.0727 6.57422 11.0362C6.62891 10.9815 6.65625 10.9268 6.65625 10.8722V6.49716H11.0312C11.0859 6.49716 11.1315 6.47893 11.168 6.44247C11.2227 6.38779 11.25 6.3331 11.25 6.27841V5.40341C11.25 5.34872 11.2227 5.30315 11.168 5.26669C11.1315 5.21201 11.0859 5.18466 11.0312 5.18466Z",
  fill: "currentColor"
});

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.7f6caf42.svg";
export { ForwardRef as ReactComponent };